import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=71326a21&scoped=true&"
import script from "./PaymentOrder.vue?vue&type=script&lang=ts&"
export * from "./PaymentOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=71326a21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71326a21",
  null
  
)

export default component.exports